import { Topic } from '@annunciate/core';
import { ContentEventNames, PlaybackEventNames } from '@annunciate/core/dist/events/interfaces/playback';
export const LEGACY_PLAYBACK_TOPICS = [
    Topic.PLAYBACK_STARTED,
    Topic.PLAYBACK_PAUSED,
];
export const SEGMENT_VIDEO_PLAYBACK_TOPICS = Object.values(PlaybackEventNames);
export const SEGMENT_VIDEO_POD_TOPICS = Object.values(ContentEventNames);
export const SEGMENT_VIDEO_TOPICS = [
    ...SEGMENT_VIDEO_PLAYBACK_TOPICS,
    ...SEGMENT_VIDEO_POD_TOPICS,
];
export const DEFAULT_TOPICS = [
    ...LEGACY_PLAYBACK_TOPICS,
    Topic.APP_BACKGROUNDED,
    Topic.APP_FOREGROUNDED,
    Topic.APP_SCREEN_VIEWED,
    Topic.APP_AUTHENTICATION_COMPLETED,
    Topic.APP_AUTHENTICATION_FAILED,
    Topic.APP_AUTHENTICATION_STARTED,
    Topic.APP_AUTHENTICATION_SIGNOUT,
    Topic.CONTENT_DOWNLOAD_COMPLETED,
    Topic.CONTENT_DOWNLOAD_DELETED,
    Topic.CONTENT_DOWNLOAD_STARTED,
    Topic.CONTENT_STATUS_COMPLETED,
    Topic.CONTENT_STATUS_UNCOMPLETED,
    Topic.CONTENT_TAG_ADDED,
    Topic.CONTENT_TAG_REMOVED,
    Topic.PURCHASE_COMPLETED,
    Topic.PURCHASE_PRODUCT_SELECTED,
    Topic.PURCHASE_STARTED,
];
//# sourceMappingURL=DEFAULT_TOPICS.js.map